module.exports = __webpack_public_path__ + "img/funnelrejected.7d9202cc.svg";